import { TemplateOverrides } from './template.overrides.request';
import { TrainingEmailEventTypes } from './training.email.event.types';

export class SendEmailForTrainingEventSubscriptionRequest {
    TrainingEventSubscriptionID: number;
    TrainingEmailEventType: TrainingEmailEventTypes;
    TemplateOverrides: TemplateOverrides;
}
